export type MatchKind = "prefix" | "infix" | "postfix"
export interface Suggestion { email: string; kind: MatchKind; at: number }

const ORDER: Record<MatchKind, number> = { prefix: 0, infix: 1, postfix: 2 }

export function rankEmailSuggestions(query: string, emails: string[], exclude: string[] = [], limit = 3): Suggestion[] {
  const q = query.trim().toLowerCase()
  if (!q) return []

  const taken = new Set(exclude.map(e => e.toLowerCase()))
  const found: Suggestion[] = []
  emails.forEach(raw => {
    const email = raw.toLowerCase()
    if (taken.has(email) || email === q) return
    const at = email.indexOf(q)
    if (at < 0) return
    const kind: MatchKind = at === 0 ? "prefix" : email.endsWith(q) ? "postfix" : "infix"
    found.push({ email, kind, at })
  })

  return found
    .sort((a, b) => ORDER[a.kind] - ORDER[b.kind] || a.email.localeCompare(b.email))
    .slice(0, limit)
}

// One request per URL per page: every chip input on a page shares the same list.
const cache = new Map<string, Promise<string[]>>()

export function loadEmailSuggestions(url: string): Promise<string[]> {
  if (!cache.has(url)) {
    cache.set(url, fetch(url, { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then(response => (response.ok ? response.json() : { emails: [] }))
      .then(data => (Array.isArray(data?.emails) ? data.emails : []))
      .catch(() => []))
  }
  return cache.get(url)!
}

// Saved addresses join the list without a reload, so the next input offers them too.
export function rememberEmail(url: string, email: string): void {
  const list = cache.get(url)
  if (list) cache.set(url, list.then(emails => (emails.includes(email) ? emails : emails.concat(email))))
}
